
// OtpVerificationForm.js
import { message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router";
import "./PasswordResetForm.css";

  const OtpVerificationForm = ({ phoneNumber, role="admin" }) => {
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otpConfirmed, setOtpConfirmed] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
   const handleOtpSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setIsLoading(true);
      const response = await axios.post("/verify-password-reset-otp", {
        phone: phoneNumber.startsWith("251") ? phoneNumber : `251${phoneNumber.substring(1)}`,
        otp
      });

      if (response.data.status === "success") {
        setOtpConfirmed(true);
        message.success("OTP verified successfully");
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Invalid or expired OTP");
    }
    finally {
      setIsLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post("/resetPassword", {
        phone: phoneNumber.startsWith("251") ? phoneNumber : `251${phoneNumber.substring(1)}`,
        password,
        confirmPassword,
        role: "admin"
      });

      if (response.data.status === "success") {
        message.success("Password reset successfully!");
        
        // Redirect based on role
        switch (role) {
          case "agent":
            navigate("/agentLogin");
            break;
          case "subAgent":
            navigate("/subAgentLogin");
            break;
          case "admin":
            navigate("/");
            break;
          default:
            navigate("/login");
        }
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to reset password");
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setConfirmPasswordError("");
    setPasswordError(
      newPassword.length < 8
        ? "Password should be at least 8 characters long"
        : ""
    );
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    setConfirmPasswordError(
      newConfirmPassword !== password ? "Passwords do not match" : ""
    );
  };

  return (
    <div className="password-reset-wrapper">
      <div className="password-reset-container">
        {otpConfirmed ? (
          <>
            <div className="password-reset-header">
              <h2>Reset Password</h2>
              <p>Enter your new password</p>
            </div>
            <form onSubmit={handlePasswordSubmit}>
              <div className="password-form-group">
                <label>New Password</label>
                <input
                  type="password"
                  className="password-input"
                  value={password}
                  onChange={handlePasswordChange}
                />
                {passwordError && <div className="error-message">{passwordError}</div>}
              </div>
              <div className="password-form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="password-input"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                {confirmPasswordError && (
                  <div className="error-message">{confirmPasswordError}</div>
                )}
              </div>
              <button
                className="submit-button"
                type="submit"
                disabled={passwordError || confirmPasswordError}
              >
                Set Password
              </button>
            </form>
          </>
        ) : (
          <>
            <div className="password-reset-header">
              <h2>Verify OTP</h2>
              <p className="otp-message">Enter the OTP sent to {phoneNumber}</p>
            </div>
            <form onSubmit={handleOtpSubmit}>
              <div className="otp-container">
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} className="otp-input" />}
                  containerStyle="otp-input-group"
                />
                {isLoading ? (
                <>
                  <div className="loading-spinner" />
                  <button type="button" className="submit-button">
                  Verifying...
                  </button>
                </>
              ) : (
                <>
                <button className="submit-button" type="submit">
                  Verify OTP
                </button>
                </>
              )}
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default OtpVerificationForm;